let lastMovement = 'down';
const addButtonMove = (characterObj, character, speed, buttons, hasLightstick) => {

        if(buttons.buttonTop.isDown) {
            lastMovement = 'up';
    
            characterObj.anims.play(`up-${character}`, true);
            characterObj.setVelocity(0, -speed)
        } else if(buttons.buttonDown.isDown) {
            lastMovement = 'down';
    
            characterObj.anims.play(`down-${character}`, true);
            characterObj.setVelocity(0, speed)
        } else if(buttons.buttonLeft.isDown) {
            characterObj.setVelocity(-speed, 0);
            lastMovement = 'left';
    
            characterObj.anims.play(`left-${character}`, true);
        } else if(buttons.buttonRight.isDown){
            characterObj.setVelocity(speed, 0);
            lastMovement = 'right';
    
            characterObj.anims.play(`right-${character}`, true);
        } else {
            characterObj.setVelocity(0, 0);

            if(!hasLightstick) {
              switch(lastMovement) {
                case 'up':
                  characterObj.anims.play(`up-static-${character}`, true);
                  break;
                case 'down':
                  // characterObj.anims.play(`turn-${character}`, true);
                  characterObj.anims.play(`repose-${character}`, true);
                  break;
                case 'left':
                  // characterObj.anims.play(`left-static-${character}`, true);
                  characterObj.anims.play(`repose-${character}`, true);
      
                  break;
                case 'right':
                  // characterObj.anims.play(`right-static-${character}`, true);
                  characterObj.anims.play(`repose-${character}`, true);
      
                  break;
                default:
                  // characterObj.anims.play(`turn-${character}`, true);
                  characterObj.anims.play(`repose-${character}`, true);
                   
                  break;
              }

            } else {
              lightstickHandler(characterObj, character);
            }
    
        }
      
    
}

const lightstickHandler = (character, nameCharacter) => {
  character.anims.play(`lightstick-${nameCharacter}`, true);
};

module.exports = {
    addButtonMove
};
